/**
 * Hide and show master header.
 */
export const Header = () => {
    const body = document.querySelector( 'body' );
    const header = document.querySelector( '#master-header' );
    const mobileButton = document.querySelector( '.mobile-menu-button' );

    document.addEventListener( 'scroll', () => {
        let viewportTop    = window.scrollY;

        if( body.classList.contains( 'page-template-main-page' ) ) {
            const hero        = document.querySelector( '.hero-full' );
            let elementTop    = hero.offsetTop;
            let elementBottom = elementTop + hero.offsetHeight;

            if( viewportTop > 80 ) {
                if( ! header.classList.contains( 'floating' ) && ! mobileButton.classList.contains( 'floating' ) ) {
                    header.classList.add( 'floating' );
                    mobileButton.classList.add( 'floating' );
                }

                if ( elementBottom < viewportTop ) {
                    if( ! header.classList.contains( 'visible' ) && ! mobileButton.classList.contains( 'visible' ) ) {
                        header.classList.add( 'visible' );
                        mobileButton.classList.add( 'visible' );
                    }
                } else {
                    if( header.classList.contains( 'visible' ) && mobileButton.classList.contains( 'visible' ) ) {
                        header.classList.remove( 'visible' );
                        mobileButton.classList.remove( 'visible' );
                    }
                }
            } else {
                if( header.classList.contains( 'floating' ) && mobileButton.classList.contains( 'floating' ) ) {
                    header.classList.remove( 'floating' );
                    mobileButton.classList.remove( 'floating' );
                }
            }
        }
    });
}

/**
 * Accordions in slide.
 */
export const Accordion = () => {
    const accordions = document.querySelectorAll( '.accordion' );

    for ( const accordion of accordions ) {

        accordion.onclick = el => {

            if( el.target.classList.contains( 'first' ) ) {
                const second = document.querySelectorAll( '.second' );
                second.forEach( acc => {
                    acc.classList.remove( 'active' );
                    acc.nextElementSibling.style.maxHeight = null;
                });

            }

            if( el.target.classList.contains( 'second' ) ) {
                const first = document.querySelectorAll( '.first' );
                first.forEach( acc => {
                    acc.classList.remove( 'active' );
                    acc.nextElementSibling.style.maxHeight = null;
                });
            }

            accordion.classList.toggle( 'active' );

            let panel = accordion.nextElementSibling;

            if( panel.style.maxHeight ) {
                panel.style.maxHeight = null
            } else {
                accordion.classList.add( 'active' );
                panel.style.maxHeight = panel.scrollHeight + 'px';
            }

            if( ( el.target.classList.contains( 'active' ) ) ) {
                document.querySelectorAll( '#slide-bottles .header' ).forEach( header => {
                    header.classList.add( 'hidden' );
                });
            } else {
                document.querySelectorAll( '#slide-bottles .header' ).forEach( header => {
                    header.classList.remove( 'hidden' );
                });
            }
        }

    }
}

/**
 * Accordions in product.
 */
export const AccordionProduct = () => {
    const accordions = document.querySelectorAll('.accordions button');

    for ( const accordion of accordions ) {
        accordion.onclick = el => {
            const toggle = el.target.classList.contains('active');
            const panel = accordion.nextElementSibling;

            accordions.forEach(_accordion => {
                _accordion.classList.remove('active');
                _accordion.nextElementSibling.style.maxHeight = null;
            })

            if (!toggle) {
                accordion.classList.add('active');
                panel.style.maxHeight = panel.scrollHeight + 'px';
            }
        }

    }
}

/**
 * Accordions in shop list.
 */
export const ShopAccordion = () => {
    const accordions = document.querySelectorAll( '.shop button' );

    for ( const accordion of accordions ) {

        accordion.onclick = () => {
            accordion.classList.toggle( 'active' );

            let panel = accordion.nextElementSibling;

            if( panel.style.maxHeight ) {
                panel.style.maxHeight = null
                panel.style.marginBottom = null;
                panel.style.opacity = '0';
            } else {
                accordion.classList.add( 'active' );
                panel.style.maxHeight = panel.scrollHeight + 'px';
                panel.style.marginBottom = "30px";
                panel.style.opacity = '1';
            }
        }

    }
}

export const Visible = ( el ) => {
    const target       = document.querySelector( el );
    let viewportTop    = window.scrollY;
    let viewportBottom = viewportTop + window.innerHeight;
    let elementTop     = target.offsetTop;
    let elementBottom  = elementTop + target.offsetHeight;

    return ( viewportBottom > elementTop && viewportTop < elementBottom );
}

// Handle events for mobile menu.
export const MobileMenu = () => {
    const body = document.querySelector( 'body' );
    const menu = document.querySelector( '.mobile-menu' );
    const button = document.querySelector( '.mobile-menu-button' );

    button.addEventListener( 'click', () => {
        body.classList.toggle( 'no-scroll' );
        button.classList.toggle( 'active' );
        menu.classList.toggle( 'open' );
    })
}

// Mobile accordions in footer.
export const MobileAccordion = () => {
    const accordions = document.querySelectorAll( '.mobile-accordion button' );

    for ( const accordion of accordions ) {

        accordion.onclick = () => {
            accordion.classList.toggle( 'active' );

            let panel = accordion.nextElementSibling;

            if( panel.style.maxHeight ) {
                panel.style.maxHeight = null
                panel.style.marginBottom = null;
                panel.style.opacity = '0';
            } else {
                accordion.classList.add( 'active' );
                panel.style.maxHeight = panel.scrollHeight + 'px';
                panel.style.marginBottom = "20px";
                panel.style.opacity = '1';
            }
        }

    }
}

/**
 * Shopping Cart.
 */
export const ShoppingCart = () => {
    const body = document.querySelector('body');

    if (!body.classList.contains( 'woocommerce-checkout' ) && document.querySelector('[data-open="cart"]')) {
        const body = document.querySelector('body');
        const open = document.querySelector('[data-open="cart"]');
        const close = document.querySelectorAll('[data-close="cart"]');
        const cart = document.querySelector('.widget-cart');
        const overlay = document.querySelector('.widget-cart .overlay');
        const sidebar = document.querySelector('.widget-cart .sidebar');

        open.onclick = e => {
            e.preventDefault();

            cart.classList.add('visible');
            body.classList.add('no-scroll');

            overlay.style.opacity = "1";
            sidebar.style.transform = "translateX(0)";
        }

        close.forEach(el => {
            el.onclick = () => {
                overlay.style.opacity = "0";
                sidebar.style.transform = "translateX(100%)";

                setTimeout(() => {
                    cart.classList.remove('visible');
                    body.classList.remove('no-scroll');
                }, 300);
            }
        })
    }
}